import { render, staticRenderFns } from "./PageHeading.vue?vue&type=template&id=0e0a6bd2&scoped=true"
import script from "./PageHeading.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageHeading.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0a6bd2",
  null
  
)

export default component.exports